import script from "./SummaryData.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryData.vue?vue&type=script&setup=true&lang=js"

import "./SummaryData.vue?vue&type=style&index=0&id=5889f313&lang=css"
import "./SummaryData.vue?vue&type=style&index=1&id=5889f313&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5889f313"]])

export default __exports__